import {
    RiCheckboxBlankCircleLine,
    RiRadioButtonLine,
} from "@remixicon/react";
import classNames from "classnames";
import React, { ReactElement, ReactNode } from "react";
import { JobFunction } from "../../../__generated__/api";
import { ARTICLES } from "../../../components/help/Help";
import Button from "../../../components/theme/button/Button";
import useArticleContext from "../../../contexts/HelpContext";
import ROLES from "../../../job-function-roles";
import Styles from "../Onboarding.module.scss";
import { StepProps } from "./base";

function OtherButton(props: StepProps & {
    jobFunction: JobFunction;
    children: ReactNode;
}) {
    const isSelected = props.profile.jobFunction === props.jobFunction;

    const icon = isSelected ? <RiRadioButtonLine /> : <RiCheckboxBlankCircleLine />;
    return (
        <div>
            <Button
                onClick={() => {
                    props.onNext({ ...props.profile, jobFunction: props.jobFunction });
                }}
                metricPath={["onboarding", "pick-role", props.jobFunction]}
                type="button"
                variant="outline-gray"
                className={classNames(
                    Styles["choice-item"],
                    isSelected ? Styles["choice-item-active"] : "",
                )}
                prefixIcon={icon}
            >
                {props.children}
            </Button>

        </div>
    );
}
export default function OnboardingStep(props: StepProps): ReactElement {
    const [isOther, setIsOther] = React.useState(
        props.profile.jobFunction === JobFunction.Other || props.profile.jobFunction === JobFunction.OtherInternal,
    );

    useArticleContext(ARTICLES.PICK_ROLE_PAGE);

    return (
        <div className={Styles["step-container"]}>

            {isOther ? (
                <>
                    <div className={Styles["step-header"]}>
                        <h2 className={Styles["step-title"]}>Who do you need to support?</h2>

                        <p>
                            Who are you looking to support - customers outside of your organization
                            or colleages within your organization?
                        </p>

                    </div>
                    <div>

                        <div className={Styles["other-role-list"]}>
                            <OtherButton
                                {...props}
                                jobFunction={JobFunction.Other}
                            >
                                External customers or partners.
                            </OtherButton>
                            <OtherButton
                                {...props}
                                jobFunction={JobFunction.OtherInternal}
                            >
                                Internal colleagues or co-workers.
                            </OtherButton>

                        </div>
                        <div className="w-100 mt-2 text-center">
                            <Button
                                type="button"
                                variant="ghost-blue"
                                metricPath={["onboarding", "pick-role", "DIFFERENT_ROLE"]}
                                onClick={() => {
                                    setIsOther(false);
                                    props.onReset();
                                }}
                            >
                                Select a different role
                            </Button>
                        </div>

                    </div>
                </>
            ) : (
                <div>

                    <div className={Styles["step-header"]}>
                        <h2 className={Styles["step-title"]}>What is your role?</h2>
                        <p>
                            To better tailor your experience, please tell us what you do.
                        </p>

                    </div>

                    <ul className={Styles["role-list"]}>
                        {ROLES.map(role => {
                            const isSelected = props.profile.jobFunction === role.jobFunction;
                            return (
                                <Button
                                    type="button"
                                    className={classNames(
                                        Styles["choice-item"],
                                        isSelected ? Styles["choice-item-active"] : "",
                                    )}
                                    metricPath={["onboarding", "pick-role",
                                        role.jobFunction === JobFunction.Other ? "OTHER_PICKER" : role.jobFunction]}
                                    key={role.jobFunction}
                                    variant="outline-gray"
                                    onClick={() => {
                                        if (role.jobFunction === JobFunction.Other) {
                                            setIsOther(true);
                                            props.onReset();
                                        } else {
                                            props.onNext({ ...props.profile, jobFunction: role.jobFunction });
                                        }
                                    }}
                                    prefixIcon={<role.icon />}
                                    // prefixIcon={<Icon variant="default" icon={<role.icon />} />}
                                >
                                    {role.title}
                                </Button>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}
